import { useEffect } from "react";
import { useToast } from "@/components/base/Toast";
import { ApiError } from "@/services/http";

/**
 * Filet de sécurité : une erreur du serveur qu'une page n'a pas interceptée (ex. « cette classe a déjà
 * un titulaire ») s'affiche en notification au lieu d'être perdue silencieusement.
 */
export default function ApiErrorNotifier() {
  const { notify } = useToast();

  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      if (!(event.reason instanceof ApiError)) return;
      event.preventDefault();
      notify(event.reason.message, "error");
    };
    window.addEventListener("unhandledrejection", onRejection);
    return () => window.removeEventListener("unhandledrejection", onRejection);
  }, [notify]);

  return null;
}
